<script>
  import { createEventDispatcher, onMount } from 'svelte';

  import SwiperNav from '$lib/swiper/Nav.svelte';
  import { Navigation } from 'swiper';

  export let years;
  export let active;

  let swiperEl, prevEl, nextEl;

  const dispatch = createEventDispatcher();

  function handleClick(year) {
    active = year.id;
    dispatch('change');
  }

  onMount(() => {
    Object.assign(swiperEl, {
      modules: [Navigation],
      slidesPerView: 'auto',
      // centeredSlides: true,
      spaceBetween: 20,
      navigation: {
        prevEl,
        nextEl,
      },
      injectStyles: ['.swiper-wrapper{justify-content:center;}'],
    });

    swiperEl.initialize();
  });
</script>

<nav class="list-year">
  <SwiperNav bind:prev={prevEl} bind:next={nextEl} />
  <swiper-container class="swiper-container" bind:this={swiperEl} init={false}>
    {#each years as year}
      <swiper-slide class="swiper-slide">
        <button
          class="list-year__link tagline"
          class:active={active == year.id}
          on:click={() => {
            handleClick(year);
          }}>{year.label}</button
        >
      </swiper-slide>
    {/each}
  </swiper-container>
</nav>

<style lang="scss">
  .list-year {
    padding: 0 5rem;
    position: relative;

    margin: 4rem 0 0;

    :global .swiper-nav {
      margin-top: -2.5rem;
    }
    :global .swiper-slide {
      margin-right: 20px;
    }

    .swiper-slide {
      width: auto;
    }

    &__link {
      position: relative;
      display: block;

      padding: 1.5rem 0;
      color: var(--royal-light);
      font-weight: 700;

      transition: all 0.25s;

      border-bottom: 1px solid transparent;

      transition: all 0.25s;

      &:hover {
        border-color: var(--aqua-1);
      }

      &.active {
        color: var(--royal);
        border-color: var(--aqua-1);
      }
    }
  }
</style>
